import axios from 'axios'

export default {
  delete: async (sitePath, id) => {
    const url = `${sitePath}/role/${id}/`
    const response = await axios.delete(url)

    return response.data
  },

  get: async (sitePath, id) => {
    const url =
      id === undefined ? `${sitePath}/role/` : `${sitePath}/role/${id}/`
    const response = await axios.get(url)

    return response.data
  },

  post: async (sitePath, data) => {
    const url = `${sitePath}/role/`
    const response = await axios.post(url, data)

    return response.data
  },

  put: async (sitePath, id, data) => {
    const url = `${sitePath}/role/${id}/`
    const response = await axios.put(url, data)

    return response.data
  },
}
